export default "__VITE_ASSET__240c0844__"